import { ApiType } from "@gymflow/common";
import { useMutation } from "@tanstack/react-query";

export const useMutationSendSMSToLeads = ({ api }: { api: ApiType }) => {
  return useMutation({
    mutationFn: async (
      payload: Parameters<ApiType["smsApi"]["sendSMSToLeads"]>[0],
    ) => {
      return (await api.smsApi.sendSMSToLeads(payload)).data;
    },
  });
};
